import { z } from 'zod'

import { ApiFetchMenuSchema } from '@/ducks/menu/menu.schema'

const ApiFetchOffersSchema = ApiFetchMenuSchema

const ApiSubmitOfferSchema = z.object({
  foodIds: z.array(z.string()),
  amount: z.number().int().gt(0),
  offerValidUntil: z.string()
})
const ApiCartDiscountSchema = z.array(
  z.object({
    _id: z.string(),
    discount_type: z.enum(['Percentage', 'Flat']),
    amount_percentage: z.number().int().nonnegative(),
    max_off: z.number().int().nonnegative(),
    target_amount: z.number().int().nonnegative(),
    expiration_time: z.string(),
    expiry_date: z.number().int(),
    status: z.number().int()
  })
)
const OfferFetchBuyXGetYSchema = z.array(
  z.object({
    _id: z.string(),
    expiry_date: z.number(),
    expiration_time: z.string(),
    offer_type: z.number().int(),
    nbr_items_purchased: z.number().int().nonnegative(),
    nbr_items_offer: z.number().int().nonnegative(),
    cumulatif: z.boolean(),
    item1: z.object({
      name: z.string(),
      _id: z.string()
    }),
    item2: z.array(
      z.object({
        name: z.string(),
        discount_percent: z.number().int().nonnegative(),
        _id: z.string()
      })
    ),
    status: z.number().int()
  })
)
export {
  ApiCartDiscountSchema,
  ApiFetchOffersSchema,
  ApiSubmitOfferSchema,
  OfferFetchBuyXGetYSchema
}
